import SubscribeForm from "../Components/SubscribeForm";

const SubscribePage = () => {
return(
    <>
    <SubscribeForm />
    </>
)
}

export default SubscribePage;